import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form';
import HelpCircle from 'react-feather/dist/icons/help-circle.js';
import Tooltip from 'rc-tooltip';
import Toggle from 'react-toggle';

import CityTypeahead from '../../Form/Field/CityTypeahead.jsx';
import Date from '../../Form/Field/Date.jsx';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Input from '../../Form/Field/Input.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Select from '../../Form/Field/Select.jsx';

import conf from '../../../conf.js';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import normBoolean from '../../Form/Normalizer/boolean.js';
import validate, {validatePrice, validateYearlyBrut} from './validate.js';

import './AdditionalInfoStepForm.scss';

export const name = 'AdditionalInfoStepForm';

class AdditionalInfoStepForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hasDefinedPrice: !!props?.initialValues.freelance.price
    }
  }

  toggleHasDefinedPrice = () => {
    this.setState({hasDefinedPrice: !this.state.hasDefinedPrice});
  }

  validatePrice = (value) => {
    return validatePrice(value)?.price ?? undefined;
  }

  validateYearlyBrut = (value) => {
    return validateYearlyBrut(value)?.yearlyBrut ?? undefined;
  }

  render() {
    return (
      <div id={name} className="additional-info-step-form">
        <form autoComplete="off" onSubmit={this.props.onSubmit}>
          <h3 className="text-center mt-5 mb-4">Statut actuel</h3>
          <Field
            label="Autorisation de travail"
            name="freelance.work_permit"
            type="select"
            component={Select}
          >
            {Object.entries(conf.workPermits).map(([key, workPermit]) => (
              <option value={workPermit.value} key={key}>{workPermit.label}</option>
            ))}
          </Field>
          <Field
            label="Statut professionnel"
            name="freelance.situation"
            type="select"
            component={Select}
          >
            {Object.entries(conf.situations).map(([key, situation]) => (
              <option value={situation.value} key={key}>{situation.label}</option>
            ))}
          </Field>

          <h3 className="text-center mt-5 mb-4">Disponibilité</h3>
          <div className="row">
            <div className="col-12 col-md-6">
              <Field
                label="Date de disponibilité *"
                name="freelance.date_available"
                placeholder="JJ/MM/AAAA"
                type="text"
                component={Date}
              />
            </div>
            <div className="col-12 col-md-6">
              <Field
                label="Commentaire"
                name="freelance.date_available_tunnel_comment"
                placeholder="disponible à temps partiel 2/5 jusqu’au JJ/MM/AAAA puis à temps complet"
                type="textarea"
                component={Input}
              />
            </div>
          </div>

          <h3 className="text-center mt-5 mb-4">Localisation et mobilité</h3>
          <div className="row">
            <div className="col-12 col-md-6">
              <Field
                label="Vous habitez la commune de *"
                name="user.city"
                placeholder="Paris, Bordeaux..."
                autocomplete="off"
                type="text"
                component={CityTypeahead}
              />
            </div>
            <div className="col-12 col-md-6 relocation-long-fulltime">
              <Field
                label="Je suis prêt à effectuer à plein temps une mission longue durée (3-6 mois par exemple) loin de chez moi"
                name="freelance.relocation_long_fulltime"
                type="checkbox"
                normalize={normBoolean}
                component={Input}
              />
            </div>
          </div>

          <h3 className="text-center mt-5 mb-4">Positionnement</h3>
          <div className="col-12 mt-2 mb-5 text-center toggle-has-defined-price">
            <label className="d-flex justify-content-center align-items-center">
              <span className={`${(this.state.hasDefinedPrice ? '' : 'focus ')}label-text mx-2`}>
                Je n'ai pas défini mon TJ
              </span>
              <Toggle icons={false} checked={this.state.hasDefinedPrice} onChange={this.toggleHasDefinedPrice}/>
              <span className={`${(this.state.hasDefinedPrice ? 'focus ' : '')}label-text mx-2`}>
                J'ai défini mon TJ
              </span>
            </label>
          </div>

          {this.state.hasDefinedPrice ?
            <Field
              label={<span>
                Taux journalier minimum en deçà duquel nous ne vous solliciterons pas. Ce TJ est indicatif et non communiqué.
                <Tooltip
                  placement="top"
                  trigger={['hover', 'click', 'focus']}
                  overlay={
                    <span>
                      Vous aurez la capacité de prendre un positionnement différent sur chaque offre de mission
                    </span>
                  }
                >
                  <HelpCircle size={20} />
                </Tooltip>
              </span>}
              name="freelance.price"
              type="number"
              component={Input}
              validate={this.state.hasDefinedPrice ? [this.validatePrice] : []}
            /> :
            <Field
              label="Si vous n’avez pas déterminé votre TJ, indiquez le montant équivalent en brut annuel que vous percevez/souhaitez percevoir"
              name="freelance.yearly_brut"
              type="number"
              component={Input}
              validate={this.state.hasDefinedPrice ? [] : [this.validateYearlyBrut]}
            />
          }

          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}>Sauvegarde en cours...</Loader>
      </div>
    );
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(AdditionalInfoStepForm);
